import { render, staticRenderFns } from "./CarregandoPadrao.vue?vue&type=template&id=878e8754&"
import script from "./CarregandoPadrao.vue?vue&type=script&lang=js&"
export * from "./CarregandoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports